export default {
	SET_USER (state, payload) {
		state.user = payload
	},
	SET_AUTH (state, payload) {
		state.auth = payload
	},
	SET_NAVIGATION (state, payload) {
		state.showNavigation = payload
	}
}
